import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { UserType } from '../../Constants/user-type';
import { FormGroup } from '@angular/forms';
import { Constant } from 'src/app/shared/Constants/constant';
import { ToastrManager } from 'ng6-toastr-notifications';
import { MatDialog } from '@angular/material/dialog';
import { SyncDataPopupComponent } from '../sync-data-popup/sync-data-popup.component';
import { EventBusService } from '../../Services/event-bus-service.service';
import { Subject, catchError, of, takeUntil, tap } from 'rxjs';
import { LoaderService } from '../../Services/loader.service';

@Component({
  selector: 'app-base',
  template: `<p>.</p>`,
  styles: [`p { color: #333; } `]
})
export class BaseComponent implements OnDestroy{
  public filteredList: any[] = [];
  public noData: boolean = false;
  public ConstantNoData: Constant = Constant.NoData;
  UserView: string = '';
  Utype: any;
  DefaultPageSize = 10;
  DefaultPageNumber = 1;
  Paginator = {
    PageSize: 10,
    Length: 0,
    PageSizeOptions: [10, 20, 30, 40],
    PageIndex: 0
  };
  Paginator2 = {
    PageSize: 10,
    Length: 0,
    PageSizeOptions: [10, 20, 30, 40],
    PageIndex: 0
  };
  showloader: boolean = true;
  showFSLoader: boolean = true;
  emailFieldConfig: any;
  protected loaderService = inject(LoaderService);
  protected tstrMgr = inject(ToastrManager);
  protected destroy$ = new Subject<void>();
  constructor() {
    this.Utype = UserType;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  getUserView(UserType: any): string {
    this.UserView = UserType;
    if (this.UserView == this.Utype.Admin) {
      if (localStorage.getItem('selectedClientId')) {
        this.UserView = this.Utype.Client;
      }
    }
    return this.UserView;
  }

  formatPhoneNumber(phoneNumber: string): string {
    if (!phoneNumber) return phoneNumber;
    const numbers = phoneNumber.replace(/\D/g, '');
    const char: { [key: number]: string } = { 3: '-', 6: '-' };
    let formatted = '';
    for (let i = 0; i < numbers.length; i++) {
      formatted += (char[i] || '') + numbers[i];
    }
    return formatted;
  }

  generatePieChartOptions(title: any, series: any, labels: any, colors: any) {
    return {
      series: series,
      chart: {
        width: 280,
        type: 'pie',
      },
      labels: labels,
      colors: colors,
      title: {
        text: title,
        style: {
          fontSize: '16px'
        }
      },
      dataLabels: {
        enabled: true,
        formatter: function (val: any, opts: { w: { globals: { series: { [x: string]: any; }; }; }; seriesIndex: string | number; }) {
          return opts.w.globals.series[opts.seriesIndex];
        },
        style: {
          fontSize: '12px',
          colors: ['#000']
        }
      },
      legend: {
        fontSize: '10px',
        position: 'bottom',
        horizontalAlign: 'left',
      }
    };
  }

  filterItems(e: any, itemList: any[], getName: (item: any) => string): any[] {
    const term = e.target.value.toLowerCase();
    this.filteredList = itemList.filter(item =>
      getName(item).toLowerCase().includes(term)
    );
    this.noData = this.filteredList.length === 0 && term.trim().length > 0;
    return this.filteredList;
  }

  onOptionSelected(
    event: any,
    itemList: any[],
    getName: (item: any) => string,
    updateForm: (selectedItem: any) => void) {
    const selectedName = event.option.value;
    const selectedItem = itemList.find(item => item.displayName === selectedName);
    if (selectedItem) {
      updateForm(selectedItem);
    }
  }

  onSelectionCallback(
    event: any,
    formGroup: FormGroup,
    controlName: string,
    displayName: string,
    callback?: (selectedItem: any) => void
  ) {
    const selectedItem = event.option?.value;

    if (selectedItem) {
      formGroup.patchValue({ [controlName]: selectedItem });
      if (callback) {
        callback(selectedItem);
      }
    }
  }

  onSelectionCallbackWithModel(
    event: any,
    formModel: any,
    property: string,
    callback?: (selectedItem: any) => void
  ) {
    const selectedItem = event.option?.value;

    if (selectedItem) {
      this.updateFormModelProperty(formModel, property, selectedItem);
      if (callback) {
        callback(selectedItem);
      }
    }
  }

  onClosedCallback(
    itemList: any[],
    originalItemList: any[],
    formGroup: FormGroup,
    controlName: string,
    displayKey: string,
    callback?: (matchedItem?: any) => void
  ) {
    const inputValue = formGroup.controls[controlName].value;
    const isTypeProvided = typeof inputValue === 'string';
    let matchedItem;

    if (isTypeProvided) {
      matchedItem = itemList.find((item) =>
        item[displayKey]?.toLowerCase() === inputValue?.toLowerCase()
      );
    } else {
      matchedItem = itemList.find((item) =>
        item[displayKey]?.toLowerCase() === inputValue[displayKey]?.toLowerCase()
      );
    }

    if (matchedItem) {
      formGroup.patchValue({ [controlName]: matchedItem });

      if (callback) {
        callback(matchedItem);
      }
    } else {
      formGroup.patchValue({ [controlName]: null });
      itemList.splice(0, itemList.length, ...originalItemList);

      if (callback) {
        callback(undefined);
      }
    }
  }

  onClosedCallbackMisc(
    itemList: any[],
    originalItemList: any[],
    formGroup: FormGroup,
    controlName: string,
    callback?: (matchedItem?: any) => void
  ) {
    const inputValue = formGroup.controls[controlName].value;

    let matchedItem;

    matchedItem = itemList.find((item) =>
      item === Number(inputValue)
    );

    if (matchedItem) {
      formGroup.patchValue({ [controlName]: matchedItem });

      if (callback) {
        callback(matchedItem);
      }
    } else {
      formGroup.patchValue({ [controlName]: null });
      itemList.splice(0, itemList.length, ...originalItemList);

      if (callback) {
        callback(undefined);
      }
    }
  }

  onClosedCallbackWithModel(
    itemList: any[],
    originalItemList: any[],
    formModel: any,
    property: string,
    displayKey: string,
    callback?: (matchedItem?: any) => void
  ) {
    const inputValue = formModel[property];
    const isTypeProvided = typeof inputValue === 'string';
    let matchedItem;

    if (isTypeProvided) {
      matchedItem = itemList.find((item) =>
        item[displayKey]?.toLowerCase() === inputValue?.toLowerCase()
      );
    } else if (inputValue && inputValue[displayKey]) {
      matchedItem = itemList.find((item) =>
        item[displayKey]?.toLowerCase() === inputValue[displayKey]?.toLowerCase()
      );
    }

    if (matchedItem) {
      this.updateFormModelProperty(formModel, property, matchedItem);
      if (callback) {
        callback(matchedItem);
      }
    } else {
      this.updateFormModelProperty(formModel, property, null);
      itemList.splice(0, itemList.length, ...originalItemList);
      if (callback) {
        callback(undefined);
      }
    }
  }

  updateFormModelProperty(formModel: any, property: string, value: any) {
    if (formModel && formModel.hasOwnProperty(property)) {
      formModel[property] = value;
    }
  }

  displayCityNew(city: any): string {
    return city ? city.cityName : '';
  }

  displayWithCC(item: any): string {
    return item && item.phoneCode ? item.phoneCode : '';
  }

  displayWithBi(item: any): string {
    return item && item.displayName ? item.displayName : '';
  }

  displayWithDC(item: any): string {
    return item && item.classificationName ? item.classificationName : '';
  }

  displayWith(item: any): string {
    return item && item.displayName ? item.displayName : '';
  }
  displayWithLableName(item: any): string {
    return item && item.label ? item.label : '';
  }

  displayWithManager(item: any): string {
    return item && item.fullName ? item.fullName : '';
  }

  displayWithLoc(item: any): string {
    return item && item.locationInfo ? item.locationInfo : '';
  }

  displayWithH(item: any): string {
    return item ? item : '';
  }
  displayWithDocName(item: any): string {
    return item ? item.docName : '';
  }
  displayCountry(country: any): string {
    return country && country.countryName ? country.countryName : '';
  }
  displayState(state: any): string {
    return state && state.stateName ? state.stateName : '';
  }
  displayCity(city: any): string {
    return city && city.cityName ? city.cityName : '';
  }
  displayBU(bu: any): string {
    return bu && bu.name ? bu.name : '';
  }
  displayCC(cc: any): string {
    return cc && cc.name ? cc.name : '';
  }
  displayManager(mm: any): string {
    return mm && mm.fullName ? mm.fullName : '';
  }
  copyFormValues(
    sourceForm: FormGroup,
    targetForm: FormGroup,
    fieldMappings: { sourceControlName: string; targetControlName: string; nestedKey?: string }[]
  ) {
    fieldMappings.forEach(({ sourceControlName, targetControlName, nestedKey }) => {
      const sourceControl = sourceForm.get(sourceControlName);
      const targetControl = targetForm.get(targetControlName);

      if (sourceControl && targetControl) {
        const sourceValue = sourceControl.value;

        if (nestedKey && sourceValue && typeof sourceValue === 'object') {
          targetControl.setValue(sourceValue[nestedKey]);
        } else {
          targetControl.setValue(sourceValue);
        }
      }
    });
  }

  setFormControlValueGeneric(
    formGroup: FormGroup,
    controlName: string,
    id: string | undefined,
    categoryList: any[],
    searchKey: string,
    valueKey?: string
  ): void {
    const control = formGroup.get(controlName);

    if (!control) {
      console.warn(`Control ${controlName} not found in form group`);
      return;
    }

    if (!id) {
      control.setValue(null);
      return;
    }

    const item = categoryList.find((x: any) => String(x[searchKey]) === String(id));

    if (item) {
      const value = valueKey ? item[valueKey] : item;
      control.setValue(value);
    } else {
      control.setValue(null);
    }
  }

  onOptionSelectedUser(
    event: any,
    itemList: any[],
    getName: (item: any) => string,
    updateForm: (selectedItem: any) => void
  ) {
    const selectedName = event.option.value;
    const selectedItem = itemList.find(item => item.name === selectedName);
    if (selectedItem) {
      updateForm(selectedItem);
    }
  }

  onOptionSelectedMan(
    event: any,
    itemList: any[],
    getName: (item: any) => string,
    updateForm: (selectedItem: any) => void
  ) {
    const selectedName = event.option.value;
    const selectedItem = itemList.find(item => item.fullName === selectedName);
    if (selectedItem) {
      updateForm(selectedItem);
    }
  }

  setFormControlValueBase(
    form: FormGroup,
    controlName: string,
    id: string | undefined,
    categoryList: any[],
    lookUpKey: string,
    displayKey: string
  ) {
    const item = categoryList.find((x: any) => x[lookUpKey] === id);
    if (item) {
      form.controls[controlName].setValue(item[displayKey]);
    }
  }

  onBlurCheck(list: any[], originalList: any[], form: FormGroup, searchField: string, nameField: string, idField: string): void {
    const nameValue = form.get(nameField)?.value;
    const exactMatch = list.find(item => item[searchField].toLowerCase() === nameValue?.toLowerCase());

    if (!exactMatch) {
      form.patchValue({
        [idField]: '',
        [nameField]: ''
      });
      form.get(idField)?.setErrors({ required: true });
      list.length = 0;
      list.push(...originalList);
    }
  }

  showToastr(
    message: string,
    typeOrOptions?: 'success' | 'error' | 'warning' | 'info' | any,
    options?: any
  ) {
    // Determine if the second argument is the type or options
    const isTypeProvided = typeof typeOrOptions === 'string';

    // Set the type based on whether it is explicitly provided
    const toastrType = isTypeProvided ? typeOrOptions : 'success';

    // Merge default options with provided options
    const toastrOptions = {
      position: 'top-right',
      toastTimeout: 3000,
      dismiss: 'click',
      showCloseButton: true,
      ...(isTypeProvided ? options : typeOrOptions)
    };

    // Display toastr based on the determined type
    switch (toastrType) {
      case 'success':
        this.tstrMgr.successToastr(message, '', toastrOptions);
        break;
      case 'error':
        this.tstrMgr.errorToastr(message, '', toastrOptions);
        break;
      case 'warning':
        this.tstrMgr.warningToastr(message, '', toastrOptions);
        break;
      case 'info':
        this.tstrMgr.infoToastr(message, '', toastrOptions);
        break;
      default:
        throw new Error(`Unsupported toastr type: ${toastrType}`);
    }
  }

  syncDataPopup(dialog: MatDialog, eventBus: EventBusService) {
    const dialogRef = dialog.open(SyncDataPopupComponent, {
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'logout') {
        eventBus.emitLogout();
      } else {

      }
    });
  }

  ValidateInput(formGroup: FormGroup, formControlName: string, idControlName: string, inputValue: string, filteredList: any[]) {
    const exactMatch = filteredList.some(item => item.displayName.toLowerCase().includes(inputValue));
    if (!exactMatch) {
      formGroup.get(idControlName)?.setValue(null);
      formGroup.get(idControlName)?.setErrors({ required: true });
    }
  }

  ValidateCountryInput(formGroup: FormGroup, formControlName: string, idControlName: string, inputValue: string, filteredList: any[]) {
    const exactMatch = filteredList.some(item => item.countryName.toLowerCase() === inputValue);
    if (!exactMatch) {
      formGroup.get(idControlName)?.setValue(null);
      formGroup.get(idControlName)?.setErrors({ required: true });
    }
  }

  formatLocationInfo(item: any): string {
    return [
      item.locationName,
      item.city,
      item.state?.stateName,
      item.countries?.countryName,
      item.zipCode
    ]
      .filter(part => part?.trim())
      .join(', ');
  }

  resetControlIfNoMatch(form: FormGroup, controlName: string, list: any[], minLength: number = 3) {
    const controlValue = form.controls[controlName].value;

    if (list?.length === 0 && controlValue?.length > minLength) {
      form.controls[controlName].setValue(null);
    }
  }

  onLoaderClosed(): void {
    this.showloader = false;
  }

  handlePasteEvent(event: ClipboardEvent, sanitizeFn: (text: string) => string, maxLength?: number): void {
    event.preventDefault();
    let pastedText = event.clipboardData?.getData('text') || '';

    let sanitizedText = sanitizeFn(pastedText?.trim());

    if (maxLength !== undefined) {
      sanitizedText = sanitizedText.slice(0, maxLength);
    }
    this.insertText(event.target as HTMLInputElement, sanitizedText);
  }

  private insertText(input: HTMLInputElement, text: string): void {
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    input.value = input.value.slice(0, start) + text + input.value.slice(end);
    input.setSelectionRange(start + text.length, start + text.length);
    input.dispatchEvent(new Event('input'));
  }

  preventNonNumericPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData;
    const pastedText = clipboardData?.getData('text') || '';

    if (isNaN(Number(pastedText))) {
      event.preventDefault();
    }
  }

  getLoaderState(): boolean {
      this.loaderService?.loaderState$.subscribe((state) => {
        return state;
      });
      return false;
  }

  showLoader(isShow:boolean){
    this.loaderService.showLoader(isShow);
  }

  truncate(value: string | null, startIndex: number = 0, maxLength: number = 20): string {
    if (!value) {
      return '';
    }
    return value.length > maxLength
      ? value.substring(startIndex, startIndex + maxLength) + '...'
      : value;
  }

  getActiveLabel(isActive: boolean): string {
    return isActive ? 'No' : 'Yes';
  }

  getBadgeClass(isActive: boolean): string {
    return isActive ? 'badge-success' : 'badge-danger';
  }

  getActiveBadgeClass(isActive: boolean): string {
    return isActive ? 'badge-success' : 'badge-inactive';
  }

  getActiveRibbonClass(isActive: boolean): string {
    return isActive ? 'verified ribbon' : 'ribbon';
  }

  getActiveText(isActive: boolean): string {
    return isActive ? 'Active' : 'Inactive';
  }
  getAcceptValue(key: string): string {
    switch (key) {
      case 'RESUME':
        return ".pdf,.doc,.docx";
      case 'IMAGE':
        return "image/png, image/jpeg";
      default:
        return '';
    }
  }
}
